export default class Marquee{
    
    constructor(element) {
        this._wrapper = element;
        this._track = this._wrapper.querySelector('.js-marquee-track');
        this._text = this._wrapper.querySelector('.js-marquee-text');
        
        this.clones = [];
        this._clonedTrack = false;
        
        this.init();
        
        this.buildMarquee();
        
        this.bindEvents();
    }
    
    init(){
        this._track.style.whiteSpace = "nowrap";
        this._wrapper.style.display = "flex";
        this._wrapper.style.alignItems = "center";
        this._wrapper.style.gap = "1em";
        this._text.style.display = "inline";
    }

    buildMarquee(){
        let times = Math.ceil(this._wrapper.offsetWidth / this._text.offsetWidth);

        for (let i = 0; i <= times; i++) {
            let clone = this._text.cloneNode(true);
            this._track.appendChild(clone);
            this.clones.push(clone);
        }
        
        this._clonedTrack = this._track.cloneNode(true);
        this._wrapper.appendChild(this._clonedTrack);
        
        this._track.classList.add('marquee');
        this._clonedTrack.classList.add('marquee');
    }
    
    bindEvents(){
        window.addEventListener('resize', app.debounce(() => {
            this.kill();
            this.buildMarquee();
        }));
    }
    
    kill(){
        this._track.classList.remove('marquee');
        this.clones.forEach((el) => {
           el.remove();
        });
        this._clonedTrack.remove();
    }
}